<div class="container">
  <div class="sidebar">
    <div class="menu">
      @for (link of navigationLinks(); track link.title; let isFirst = $first) {
        <div
          class="button"
          [class.first]="isFirst"
          [class.disabled]="link | pure: disableNavigationLink"
          [class.selected]="isSelected(link)">
          <div
            class="content"
            matTooltipPosition="right"
            [matTooltip]="link | pure: getLinkTooltip | translate"
            (click)="navigate(link)">
            <mat-icon>{{ link.icon }}</mat-icon>
          </div>
        </div>
      }
      <div
        class="action"
        (click)="onToggleMenu()">
        <p>{{ (isMenuVisible() ? 'general.close' : 'general.open') | translate }}</p>
        <mat-icon>{{ isMenuVisible() ? 'west' : 'east' }}</mat-icon>
      </div>
    </div>
  </div>
  <div
    class="flyout"
    [class.active]="isMenuVisible()"
    [class.inactive]="!isMenuVisible()">
    @for (link of navigationLinks(); track link.title) {
      <div
        class="button"
        [class.selected]="isSelected(link)"
        (click)="navigate(link)">
        <p>{{ link.title | translate }}</p>
        @if (link.tooltip) {
          <mat-icon [matTooltip]="link.tooltip | translate">info_outline</mat-icon>
        }
        @if (link.hasChilds) {
          <mat-icon>navigate_next</mat-icon>
        }
      </div>
    }
  </div>
</div>
